<script lang="ts">
  interface Props {
    columns?: number;
    children?: import('svelte').Snippet;
  }

  let { columns = 2, children }: Props = $props();
</script>

<div class="comp-input-group" style="grid-template-columns: repeat({columns}, 1fr);">
  {@render children?.()}
</div>

<style>
  .comp-input-group {
    display: grid;
    grid-column-gap: 16px;
    align-items: flex-start;
  }
</style>
